import { makeStyles } from "@material-ui/core";
import { designTokens } from "../../styles/designTokens";

export const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    noResultsContainer: {
        padding: `0 ${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
        width: '100%',
        height: '100%',
        '@media (max-width: 640px)': {
            padding: `0 ${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
        }
    },
    noResults: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        flex: 1,
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: designTokens.borderRadius.card,
        backgroundColor: designTokens.colors.background.card,
        margin: '0 auto',
        maxWidth: '1200px',
    },
    noResultsTitle: {
        ...designTokens.typography.h2,
        marginBottom: designTokens.spacing.xs,
    },
    noResultsSubtitle: {
        ...designTokens.typography.subtitle,
    },
    resultsContainer: {
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    resultCard: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: `${designTokens.borderRadius.card} !important`,
        marginBottom: designTokens.spacing.md,
        boxShadow: 'none',
        backgroundColor: designTokens.colors.background.card,
        '&:before': {
            display: 'none',
        },
        '&:first-child': {
            borderTopLeftRadius: `${designTokens.borderRadius.card} !important`,
            borderTopRightRadius: `${designTokens.borderRadius.card} !important`,
        },
        '&:last-child': {
            borderBottomLeftRadius: `${designTokens.borderRadius.card} !important`,
            borderBottomRightRadius: `${designTokens.borderRadius.card} !important`,
        },
        '&.Mui-expanded': {
            margin: `0 0 ${designTokens.spacing.md} 0`,
        },
    },
    summaryContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        gap: designTokens.spacing.xs,
        margin: '0 !important',
    },
    patientInfo: {
        ...designTokens.typography.body,
        fontWeight: 500,
        marginBottom: designTokens.spacing.xs,
    },
    orderInfo: {
        ...designTokens.typography.label,
    },
    actionsWrapper: {
        display: 'flex',
        flexDirection: 'row',
        gap: designTokens.spacing.sm,
        width: '100%',
        '@media (max-width: 970px)': {
            width: '100%',
            flexDirection: 'column',
        }
    },
    buttonWrapper: {
        width: '100%',
        maxWidth: '316px',
        minWidth: '150px',
        '@media (max-width: 970px)': {
            maxWidth: '100%',
        }
    },
    tablesContainer: {
        margin: '20px 0',
        zIndex: '100',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 6px',
    },
    loadingWrapper: {
        padding: '16px',
    },
});
